var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22,11.5c0,.276-.224,.5-.5,.5h-2.87c-.872,0-1.692-.464-2.142-1.211,0,0-1.879-3.119-1.898-3.146l-2.799,6.067c-.084,.183-.266,.291-.455,.291-.07,0-.141-.015-.209-.046-.251-.116-.36-.413-.245-.664l2.877-6.235c-.129-.036-.263-.055-.4-.055h-2.593l-2.673,5.849c-.269,.656-.022,1.429,.594,1.818l5.061,2.899c.156,.089,.251,.255,.251,.434v5.5c0,.276-.224,.5-.5,.5s-.5-.224-.5-.5v-5.21l-4.828-2.766c-1.046-.661-1.457-1.948-.996-3.073l2.491-5.451h-2.931c-.571,0-1.085,.318-1.341,.829l-1.447,2.895c-.124,.247-.424,.346-.671,.224-.247-.124-.347-.424-.224-.671l1.447-2.895c.427-.853,1.283-1.382,2.236-1.382h6.624c.872,0,1.692,.464,2.142,1.211l1.844,3.062c.27,.448,.762,.727,1.285,.727h2.87c.276,0,.5,.224,.5,.5Zm-15.312,5.278c-.254-.103-.548,.021-.65,.279-.229,.573-.776,.943-1.393,.943H1.5c-.276,0-.5,.224-.5,.5s.224,.5,.5,.5h3.146c1.028,0,1.939-.617,2.321-1.572,.103-.256-.022-.547-.279-.65ZM11,2.5c0-1.378,1.122-2.5,2.5-2.5s2.5,1.122,2.5,2.5-1.122,2.5-2.5,2.5-2.5-1.122-2.5-2.5Zm1,0c0,.827,.673,1.5,1.5,1.5s1.5-.673,1.5-1.5-.673-1.5-1.5-1.5-1.5,.673-1.5,1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.a62fb94c0a88d798171a9e23c70e8e98.svg";
export { ForwardRef as ReactComponent };